import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopNavbar } from './TopNavbar'
import { ContentArea } from './ContentArea'
import { QuickLockDialog, BatchCheckDialog } from '@/components/customers'
import { useCustomerHotkeys } from '@/hooks/useCustomerHotkeys'

export function MainLayout() {
	// 全局对话框状态
	const [quickLockOpen, setQuickLockOpen] = useState(false)
	const [batchWechatOpen, setBatchWechatOpen] = useState(false)
	const [batchMobileOpen, setBatchMobileOpen] = useState(false)

	// 注册全局快捷键
	useCustomerHotkeys({
		onQuickLock: () => setQuickLockOpen(true),
		onBatchWechat: () => setBatchWechatOpen(true),
		onBatchMobile: () => setBatchMobileOpen(true),
	})

	return (
		<div className="flex h-screen overflow-hidden bg-background">
			{/* 侧边栏 */}
			<Sidebar />

			{/* 主内容区域 */}
			<div className="flex flex-1 flex-col overflow-hidden">
				{/* 顶部导航栏 */}
				<TopNavbar />

				{/* 内容区域 */}
				<ContentArea>
					<Outlet />
				</ContentArea>
			</div>

			{/* 全局对话框 */}
			<QuickLockDialog open={quickLockOpen} onOpenChange={setQuickLockOpen} />
			<BatchCheckDialog open={batchWechatOpen} onOpenChange={setBatchWechatOpen} type={2} />
			<BatchCheckDialog open={batchMobileOpen} onOpenChange={setBatchMobileOpen} type={1} />
		</div>
	)
}

// 导出所有布局组件
export { Sidebar } from './Sidebar'
export { TopNavbar } from './TopNavbar'
export { ContentArea } from './ContentArea'
export { SidebarMenuItem } from './SidebarMenuItem'
